export const EMPTY_FEATURE_COLLECTION = {
	type: 'FeatureCollection',
	features: [],
};
